import { render, staticRenderFns } from "./SysCfg.vue?vue&type=template&id=467544db&scoped=true"
import script from "./SysCfg.vue?vue&type=script&lang=js"
export * from "./SysCfg.vue?vue&type=script&lang=js"
import style0 from "./SysCfg.vue?vue&type=style&index=0&id=467544db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467544db",
  null
  
)

export default component.exports